/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
import {
  bus
} from '@/main';
import requestMemberPopup from '../request-for-member-popup/index.vue'
import countries from '@/services/country.json'
export default {
  name: 'core-team-sent-request',
  components: {
    'request-member-popup' : requestMemberPopup,
  },
  props: [],
  data () {
    return {
      myCoreTeamListData:null,
      myCoreTeamListDataResults:[],
      countryList:[],
      search_term:'',
      searchUserListState:false,
      requestMemberPopupState:false,
      searchUsersData:null,
      searchUsersList:[]
    }
  },
  computed: {

  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.myCoreTeamListMethod();
    bus.$on('requestMemberPopupStateBus', (data) => {
      this.requestMemberPopupState = data
      if(data == false){
        this.search_term = ''
        this.searchUserListState = false
        this.myCoreTeamListMethod();
      }
    })
  },
  methods: {
    requestMemberPopupMethod(Data){
      this.requestMemberPopupState = true
      this.requestMemberinfo = Data
      $('body').addClass('body_right_scroll_remove')
    },
    validateSearchModelsBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.search_term.length >= 5){
            this.$store.dispatch('searchUserForTeamHeadFun', { search_term: this.search_term }).then((response) => {
              this.searchUserListState = true
              this.searchUsersData = response.data
              this.searchUsersList = this.searchUsersData.data
            })
          }else{
            this.searchUserListState = false
            this.searchUsersData = null
            this.searchUsersList = []
          }
        }
      })
    },
    myCoreTeamListMethod(){
      this.$store.dispatch('getMyCoreTeamFiltersFun', {filter_key:'requested'}).then((res) => {
        this.myCoreTeamListData = res.data.data
        this.myCoreTeamListDataResults = this.myCoreTeamListData.results
      })
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  }
}